import { render, staticRenderFns } from "./AscAppLink.vue?vue&type=template&id=8945de4e&"
import script from "./AscAppLink.vue?vue&type=script&lang=js&"
export * from "./AscAppLink.vue?vue&type=script&lang=js&"
import style0 from "./AscAppLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports